export namespace AccountWallModels {
  export interface WallWithAssignment {
    _id: string;
    name: string;
    tilesCount: number;
    createdAt: number;
    isAssigned: boolean;
    tags?: string[];
  }

  export interface QueryParamFilters {
    query: string | null;
    cameraIdsIncludes: string[];
    tagIds: string | null;
  }

  export const DEFAULT_QUERY_FILTERS: QueryParamFilters = {
    query: null,
    cameraIdsIncludes: [],
    tagIds: null,
  };

  export const PAGE_LIMIT = 100;
}
